const PASTEL_COLORS = [
  'hsl(0, 45%, 30%)',
  'hsl(30, 45%, 30%)',
  'hsl(60, 40%, 28%)',
  'hsl(90, 40%, 28%)',
  'hsl(120, 35%, 28%)',
  'hsl(160, 40%, 28%)',
  'hsl(190, 45%, 30%)',
  'hsl(210, 45%, 32%)',
  'hsl(240, 40%, 32%)',
  'hsl(270, 40%, 32%)',
  'hsl(300, 35%, 30%)',
  'hsl(330, 40%, 30%)',
];

function hashName(name: string): number {
  let sum = 0;
  for (let i = 0; i < name.length; i++) {
    sum += name.charCodeAt(i);
  }
  return sum % PASTEL_COLORS.length;
}

interface ProductCardProps {
  product: { key: string; name: string; price: number };
  quantity: number;
  onTap: () => void;
}

export function ProductCard({ product, quantity, onTap }: ProductCardProps) {
  const bgColor = PASTEL_COLORS[hashName(product.name)];

  const formattedPrice = product.price
    .toFixed(2)
    .replace('.', ',');

  return (
    <button
      type="button"
      className="card relative w-full text-left cursor-pointer"
      style={{ backgroundColor: bgColor }}
      onClick={onTap}
    >
      <p className="text-lg font-semibold text-white leading-tight mb-2 line-clamp-2">
        {product.name}
      </p>
      <p className="text-2xl font-bold text-white">
        {formattedPrice}&nbsp;&euro;
      </p>

      {quantity > 0 && (
        <span className="absolute -top-2 -right-2 bg-danger rounded-full w-8 h-8 flex items-center justify-center text-white font-bold text-sm">
          {quantity}
        </span>
      )}
    </button>
  );
}
